import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { formatNumber } from '~/utils';

import type { TypeStockReleaseGoods } from '~/types/stock.types';

const formatQuantity = (value: unknown): string => formatNumber(typeof value === 'number' ? value : 0);

const RIGHT_ALIGN = { cellStyle: { textAlign: 'right' } } as const;

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 등록 > 반출 재고 조회 테이블
 */
const getStockReleaseRegisterInventoryColumnDefs = () => {
  const getRowId = (row: TypeStockReleaseGoods) => String(row.skuCode);

  const columnDefs: TypeTableColumn<TypeStockReleaseGoods>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 44,
      meta: { selection: true },
    },
    {
      accessorKey: 'barcode',
      header: '상품 바코드',
      size: 140,
    },
    {
      accessorKey: 'skuCode',
      header: 'SKU코드',
      size: 140,
    },
    {
      accessorKey: 'clusterCodeObject.name',
      header: '반출 출발지 센터',
      size: 116,
    },
    {
      accessorKey: 'temperatureTypeCodeObject.name',
      header: '보관 유형',
      size: 76,
    },
    {
      accessorKey: 'skuName',
      header: '상품명',
      size: 240,
    },
    {
      accessorKey: 'totalQuantity',
      header: '전체 재고',
      size: 76,
      cell: ({ getValue }) => formatQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'availableQuantity',
      header: '가용 재고',
      size: 76,
      cell: ({ getValue }) => formatQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'allocationQuantity',
      header: '작업중 재고',
      size: 100,
      cell: ({ getValue }) => formatQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'holdingQuantity',
      header: '보류 재고',
      size: 90,
      cell: ({ getValue }) => formatQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'defectiveQuantity',
      header: '불용 재고',
      size: 90,
      cell: ({ getValue }) => formatQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
  ];

  return { getRowId, columnDefs };
};

export default getStockReleaseRegisterInventoryColumnDefs;
